import styled from "styled-components";

export const PayStyleSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 45px;
  padding: 10px;
`;
